export var DocumentationLegacyPageBlockShortcutType;
(function (DocumentationLegacyPageBlockShortcutType) {
    DocumentationLegacyPageBlockShortcutType["external"] = "External";
    DocumentationLegacyPageBlockShortcutType["internal"] = "Internal";
})(DocumentationLegacyPageBlockShortcutType || (DocumentationLegacyPageBlockShortcutType = {}));
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocumentationLegacyPageBlockShortcut {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        // First, configure type of the block properly
        if (model.url) {
            this.type = DocumentationLegacyPageBlockShortcutType.external;
        }
        else {
            this.type = DocumentationLegacyPageBlockShortcutType.internal;
        }
        // Configure visual block information
        this.title = this.shortcutTitleFromModel(model, this.type);
        this.description = this.shortcutDescriptionFromModel(model, this.type);
        this.previewUrl = this.shortcutPreviewUrlFromModel(model);
        // Configure linking for pages and group inside documentation
        if (this.type === DocumentationLegacyPageBlockShortcutType.internal &&
            ((_a = model.documentationItemPreview) === null || _a === void 0 ? void 0 : _a.valid) &&
            model.documentationItemId) {
            this.internalId = model.documentationItemId;
        }
        else {
            this.internalId = null;
            // Configure for external URLs
            if (this.type === DocumentationLegacyPageBlockShortcutType.external &&
                model.url) {
                this.externalUrl = model.url;
            }
            else {
                this.externalUrl = null;
            }
        }
    }
    shortcutTitleFromModel(model, type) {
        var _a, _b, _c, _d, _e;
        let result = null;
        if (model.title && model.title.trim().length > 0) {
            result = model.title;
        }
        else if (type === DocumentationLegacyPageBlockShortcutType.internal) {
            result = (_b = (_a = model.documentationItemPreview) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : null;
        }
        else if (type === DocumentationLegacyPageBlockShortcutType.external) {
            result = (_e = (_d = (_c = model.urlPreview) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : model.url) !== null && _e !== void 0 ? _e : null;
        }
        if (!result || result.trim().length === 0) {
            return null;
        }
        return result;
    }
    shortcutDescriptionFromModel(model, type) {
        var _a;
        let result = null;
        if (model.description && model.description.trim().length > 0) {
            result = model.description;
        }
        else if (type === DocumentationLegacyPageBlockShortcutType.external) {
            // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
            result = (_a = model.urlPreview) === null || _a === void 0 ? void 0 : _a.description;
        }
        if (!result || result.trim().length === 0) {
            return null;
        }
        return result;
    }
    shortcutPreviewUrlFromModel(model) {
        var _a, _b, _c, _d, _e;
        return ((_e = (_c = (_a = model.assetUrl) !== null && _a !== void 0 ? _a : (_b = model.asset) === null || _b === void 0 ? void 0 : _b.url) !== null && _c !== void 0 ? _c : (_d = model.urlPreview) === null || _d === void 0 ? void 0 : _d.thumbnailUrl) !== null && _e !== void 0 ? _e : null);
    }
}
